// requestCache.js
import Vue from 'vue';
import md5 from 'js-md5'; 
import qs from 'qs'; 

const state = {
  cache: {} // 缓存对象
};

const mutations = {
  setCache(state, { key, value }) {
    Vue.set(state.cache, key, value);
  },
  deleteCache(state, key) {
    Vue.delete(state.cache, key);
  }
};

const actions = {
  setRequestCache({ commit }, { params, value }) {
    const key = md5(qs.stringify({ ...params, ccs_rc_timestamp: Date.now() }));
    commit('setCache', { key, value });
    return key; // 返回缓存的 key
  },
  getRequestCache({ state, commit }, { key, deleteValue = true }) {
    const ret = state.cache[key];
    if (deleteValue) {
      commit('deleteCache', key);
    }
    return ret;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
